module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-cell-box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCell),
      expression: "showCell"
    }],
    staticClass: "weui-cell vux-tap-active",
    class: {
      'weui-cell_access': !_vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("title", function() {
    return [(_vm.title) ? _c('label', {
      staticClass: "weui-label",
      class: _vm.labelClass,
      style: (_vm.labelStyles),
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }) : _vm._e()]
  }, {
    "labelClass": "weui-label",
    "labelStyle": _vm.labelStyles,
    "labelTitle": _vm.title
  }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-primary vux-popup-picker-select-box"
  }, [_c('div', {
    staticClass: "vux-popup-picker-select",
    style: ({
      textAlign: _vm.valueTextAlign
    })
  }, [(!_vm.displayFormat && !_vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]) : _vm._e(), _vm._v(" "), (!_vm.displayFormat && _vm.showName && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm._f("value2name")(_vm.value, _vm.data)))]) : _vm._e(), _vm._v(" "), (_vm.displayFormat && _vm.value.length) ? _c('span', {
    staticClass: "vux-popup-picker-value vux-cell-value"
  }, [_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]) : _vm._e(), _vm._v(" "), (!_vm.value.length && _vm.placeholder) ? _c('span', {
    staticClass: "vux-popup-picker-placeholder vux-cell-placeholder",
    domProps: {
      "textContent": _vm._s(_vm.placeholder)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: (_vm.isTransferDom),
      expression: "isTransferDom"
    }]
  }, [_c('popup', {
    staticClass: "vux-popup-picker",
    attrs: {
      "id": ("vux-popup-picker-" + _vm.uuid),
      "popup-style": _vm.popupStyle
    },
    on: {
      "on-hide": _vm.onPopupHide,
      "on-show": _vm.onPopupShow
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "vux-popup-picker-container"
  }, [_c('popup-header', {
    attrs: {
      "left-text": _vm.cancelText || '取消',
      "right-text": _vm.confirmText || '完成',
      "title": _vm.popupTitle
    },
    on: {
      "on-click-left": function($event) {
        return _vm.onHide(false)
      },
      "on-click-right": function($event) {
        return _vm.onHide(true)
      }
    }
  }), _vm._v(" "), _c('picker', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "fixed-columns": _vm.fixedColumns,
      "container": '#vux-popup-picker-' + _vm.uuid,
      "column-width": _vm.columnWidth
    },
    on: {
      "on-change": _vm.onPickerChange
    },
    model: {
      value: (_vm.tempValue),
      callback: function($$v) {
        _vm.tempValue = $$v
      },
      expression: "tempValue"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd101a0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/popup-picker/index.vue
// module id = 308
// module chunks = 1